import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import eye from "../../../assets/img/icons/eye-solid.svg"
import "./DoorstepServices.css"
import { ICategory, IProfessionalService, IService } from "src/helper/interfaces";
import { IDoorstepCategory } from "src/helper/interfaces";
import Cookies from "js-cookie";
import edit from "../../../assets/img/icons/icons8-edit.svg"
import placeholderImg from "../../../assets/img/landscape-placeholder-svgrepo-com.svg";
import Paginator from "src/components/layout/Paginator";
import { useBackContext } from "src/hooks/context/BackContext";
import { Link } from "react-router-dom";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import LoadingGif from "src/components/layout/Loader";

interface InitialValuesType {
   _id: string;
   description: string[];
   worker_category_id: string;
   service_title: string;
   service_image: string | null;
   price: string;
   about: string;
   working_basis: string;
   hours_count: string;
   category_name: string;
   createdAt: string; // Consider using Date type if you need date manipulation
   price_per_half_hour: string;
   price_per_hour: string;
   service_providers: string[];
   service_type: string;
   worker_type: string;

}


const getAllServices = async (token: string, pageNumber: number, pageSize: number, searchValue: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-services`, {
      headers: {
         "x-access-token": token
      },
      params: {
         service_type: "professional_worker",
         page: pageNumber,
         search_value: searchValue,
         pageSize
      }

   })
};
const getAllCategories = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/categories`, {
      headers: {
         "x-access-token": token
      }
   })
};
type InputValues = {
   [key: string]: string;
};


const ProfessionalServices = () => {
   const { setIsBackClicked } = useBackContext();
   const { isBackClicked } = useBackContext();
   const [categories, setCategories] = useState<IDoorstepCategory[]>([]);
   const loading = useAppSelector(state => state?.loading?.value);
   const [show, setShow] = useState({
      edit: false,
      create: false,
      view: false
   });
   const dispatch = useAppDispatch();
   const initialValues: InitialValuesType = {
      _id: "",
      description: [],
      worker_category_id: "",
      service_title: "",
      service_image: null,
      price: "",
      about: "",
      working_basis: "",
      hours_count: "",
      category_name: "",
      createdAt: "", // Consider using Date type if you need date manipulation
      price_per_half_hour: "",
      price_per_hour: "",
      service_providers: [],
      service_type: "",
      worker_type: ""

   };
   const Token = Cookies.get("token");
   const [selectedService, setSelectedService] = useState(initialValues);
   const [inputValues, setInputValues] = useState<InputValues>({});
   const [counter, setCounter] = useState(1);
   const [searchVal, setSearchVal] = useState("");
   const [doorStepServices, setDoorstepServices] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [confirmDel, setConfirmDel] = useState(false);
   const [hideAllFilters, setHideAllFilters] = useState(false);

   useEffect(() => {
      dispatch(startLoading());
      getAllServices(Token as string, pageNo, pageSize, searchVal)
         .then((res) => {
      // console.log(res)
         if (res?.data?.status_code === 200) {
            setDoorstepServices(res?.data?.data?.data);
            setTotalPages(res?.data?.data?.totalPages)
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,
               footer: '<a href="#">Why do I have this issue?</a>'
            });
         }
         }).catch((err) => {
            console.log(err)
         }).finally(() => {
            dispatch(stopLoading());
      })
   }, [Token, show?.edit, show?.create, pageNo, searchVal, confirmDel])

   const handleClick = () => {
      setCounter(counter + 1);
      // console.log(counter);
   };
   const onCreate = () => {
      setShow({
         ...show,
         edit: false,
         view: false,
         create: true
      });
      setIsBackClicked(false);
      setHideAllFilters(true);
      setSelectedService({
         _id: "",
         description: [],
         worker_category_id: "",
         service_title: "",
         service_image: null,
         price: "",
         about: "",
         working_basis: "",
         hours_count: "",
         category_name: "",
         createdAt: "", // Consider using Date type if you need date manipulation
         price_per_half_hour: "",
         price_per_hour: "",
         service_providers: [],
         service_type: "",
         worker_type: ""
      })
   }
   //  this below code is for Category name 
   const handleDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      // setSelectedValue(event.target.value);
      setSelectedService({ ...selectedService, worker_category_id: event.target.value });

      // console.log(event.target.value)
   };

   const handleWorkBasisChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      setSelectedService({ ...selectedService, working_basis: event.target.value });

      // console.log(event.target.value?.toLocaleLowerCase())
   };


   useEffect(() => {
      if (Token) {
         getAllCategories(Token).then((res) => {
            // console.log(res?.data?.data);
            if (res?.data?.status_code === 200) {
               // console.log(res?.data?.data)
               const professionalCats = res?.data?.data?.filter((cat: ICategory) => (cat.type === "architect") || (cat.type === "engineer"))
               // console.log(professionalCats)
               setCategories(professionalCats)
            }
         })
            .catch((err: any) => {
               console.log(err)
            })
      }

   }, [Token]);


   const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {

      event.preventDefault();
      const formData = new FormData();
      // console.log(inputs);
      formData.append('worker_Category_id', selectedService.worker_category_id);
      formData.append('price', selectedService.price);
      formData.append('about', selectedService.about);
      formData.append('service_title', selectedService.service_title);
      formData.append('working_basis', selectedService.working_basis?.toLocaleLowerCase());
      formData.append('hours_count', selectedService.hours_count);
      Object.values(inputValues).map((data, key) => {
         formData.append('service_description', data);
      })

      if (selectedService.service_image) {
         formData.append('service_image', selectedService.service_image);
      }
      if (!Token) return;
      // Add new food item
      // console.log(formData)
      postData(formData)

   }

   const postData = async (data: FormData) => {
      try {
         dispatch(startLoading());
         await axios.post(`${AppConfig.DEV_SERVER}/professional/services`, data, {
            headers: {

               'content-type': 'multipart/form-data',
               "X-Access-Token": Token
            }
         }).then((res) => {
            // console.log("res: ", res?.data)
            if (res?.data?.status_code !== 200) {
               dispatch(stopLoading());
               Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Error..!",
                  text: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 3000
               })
            }

            else
               if (res?.data?.status_code === 200) {
                  setTimeout(() => {
                     dispatch(stopLoading());
                     // setModalShow(false);
                     setShow({
                        ...show,
                        create: false
                     })
                     Swal.fire({
                        position: "center",
                        icon: "success",
                        text: `${res?.data?.msg}`,
                        title: "Saved Successfully..",
                        showConfirmButton: false,
                        timer: 3500
                     })
                  }, 1000 * 2)
               }
         })

         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   };


   const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;
      setSelectedService({ ...selectedService, [name]: value });
   }

   const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target;  // The name contains description-${id}
      // console.log(event.target)
      setSelectedService((prevState) => ({
         ...prevState,
         [name]: value  // Updates the specific description field based on the name
      }));
   };


   const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const abc: { [key: string]: string } = {};
      abc[e.target.className] = e.target.value; // Error here
      setInputValues({ ...inputValues, ...abc });
      // console.log(abc)
   };



   const clickOnEdit = (id: string, type: string) => {
      const servicToEdit = doorStepServices.find((service: IService) => service._id === id);
      if (servicToEdit !== undefined) {
         // console.log("servicToEdit: ", servicToEdit);
         setSelectedService({
            ...selectedService,
            _id: servicToEdit?._id,
            about: servicToEdit?.about,
            category_name: servicToEdit?.category_name,
            description: servicToEdit?.description,
            price: servicToEdit?.price,
            service_image: servicToEdit?.service_image,
            service_providers: servicToEdit?.service_providers,
            service_title: servicToEdit?.service_title,
            service_type: servicToEdit?.service_type,
            worker_type: servicToEdit?.worker_type,
            worker_category_id: servicToEdit?.worker_category_id,

         });
         // setSelectedService(servicToEdit);
      };
      if (type === "view") {
         setShow({
            ...show,
            view: true
         })
      }
      else if (type === "edit") {
         setShow({
            ...show,
            edit: true
         })
      }

   }

   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files as string | null;
      if (file && file.length !== 0) {
         setSelectedService({ ...selectedService, service_image: file[0] })
      }
      // setInputs({ ...inputs, service_image: file?. });
      // console.log(file);
   };

   const handleDeleteConfirmed = (id: string) => {
      // console.log(id);
      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      dispatch(startLoading());
      // Dispatch the delete action here
      Swal.fire({
         title: 'Are you sure?',
         text: "You won't be able to revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete it!'
      }).then(async (response) => {
         if (response.isConfirmed) {

            await axios({
               url: `${AppConfig.DEV_SERVER}/doorstep-service/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {

               if (res?.data?.status_code !== 200) {
                  setConfirmDel(!confirmDel)
                  Swal.fire({
                     position: "center",
                     icon: "error",
                     title: "Error..!",
                     text: `${res?.data?.msg}`,
                     showConfirmButton: false,
                     timer: 3000
                  })
               }
               else {
                  setConfirmDel(!confirmDel)
                  Swal.fire(
                     'Deleted!',
                     `${res?.data?.msg}`,
                     'success'
                  )
               }


            }).catch((err) => {
               console.log(err)
            })
         }
      }
      )
         .catch((err) => console.log(err))
         .finally(() => {
            dispatch(stopLoading());
         })
   };
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   useEffect(() => {
      if (isBackClicked) {
         setHideAllFilters(!isBackClicked)
      }
   }, [isBackClicked]);
   return (
      <MainLayout
         showAllFilters={hideAllFilters}
         searchValue={searchVal}
         onChange={(e) => setSearchVal(e.target.value)}
         clearValChange={clearSearchValue}
      >

         <div className="mt-3 mb-3">
            {
               loading ?
                  <div>
                     <LoadingGif />
                  </div>

                  : ""
            }
            <div className="card category-main me-2 p-2 p-md-4">

               {
                  show.view && !isBackClicked ?
                     <div className="row justify-content-evenly pt-3 pb-3">
                        <div className="col-lg-10 card d-flex flex-column p-5 gap-3 basic-details-div">
                           <strong className="text-start">
                              Doorstep Service Details
                           </strong>
                           <div className="d-flex flex-column gap-3">
                              {/* <span className="text-start"> Icon :</span> */}
                              <div className="d-flex justify-content-start align-items-center user-pic">
                                 <img
                                    src={
                                       selectedService?.service_image
                                          ? typeof selectedService.service_image === 'string'
                                             ? selectedService.service_image
                                             : URL.createObjectURL(selectedService.service_image)
                                          : undefined
                                    }
                                    alt={selectedService?.service_title}
                                 />
                              </div>
                           </div>

                           <div className="d-flex flex-column gap-2">

                              <div className="d-flex gap-3">
                                 <span className="left-side">Service Id :</span>
                                 <span className="right-side"> {selectedService?._id ?? "NA"}</span>
                              </div>
                              <div className="d-flex gap-3">
                                 <span className="left-side">Service Title :</span>
                                 <span className="right-side"> {selectedService?.service_title ?? "NA"}</span>
                              </div>
                              <div className="d-flex gap-3">
                                 <span className="left-side">Category Name :</span>
                                 <span className="right-side"> {selectedService?.category_name} </span>
                              </div>

                              <div className="d-flex gap-2">
                                 <span className="left-side" >Price :</span>
                                 <span className="right-side"> {selectedService?.price}</span>
                              </div>

                              {
                                 selectedService?.worker_type === "engineer" ?
                                    <div className="d-flex gap-3">
                                       <span className="left-side">Working Basis :</span>
                                       <span className="right-side"> {selectedService?.price_per_half_hour ?? "NA"}</span>
                                    </div> : ''
                              }
                              {
                                 selectedService?.worker_type === "engineer" ?
                                    <div className="d-flex gap-3">
                                       <span className="left-side">Hours Count :</span>
                                       <span className="right-side"> {selectedService?.hours_count ?? "NA"}</span>
                                    </div> : ''
                              }

                              <div className="d-flex gap-3">
                                 <span className="left-side">Description :</span>
                                 <span className="right-side"> {selectedService?.description?.join(", ") ?? "NA"}</span>
                              </div>
                              <div className="d-flex gap-3">
                                 <span className="left-side">About :</span>
                                 <span className="right-side"> {selectedService?.about?.length !== 0 ? selectedService?.about : "NA"}</span>
                              </div>


                           </div>
                        </div>

                        <div className="col-md-12 d-flex  align-items-center justify-content-between pt-5">
                           <button type="button" className="btn btn-dark" onClick={() => setShow({
                              ...show,
                              view: false
                           })}>Back</button>

                        </div>
                     </div>
                     :
                     show.edit && !isBackClicked ?
                        <form onSubmit={handleFormSubmit} className="form-div">
                           <div className="row">
                              <div className="col-6 mb-3">

                                 <div className="inputs mb-2">
                                    <div className=" d-flex flex-column align-items-start ">
                                       <label htmlFor="service_title">Service Title</label>
                                       <input onChange={handleChange} value={selectedService?.service_title} name="service_title" type="text" id="service_title" aria-describedby="service_title" placeholder="Enter service Title" required />
                                    </div>

                                 </div>
                                 <div className="inputs mb-2">
                                    <div className="d-flex flex-column align-items-start ">
                                       <label htmlFor="price"> Price</label>
                                       <input onChange={handleChange} value={selectedService?.price} name="price" type="text" id="price" placeholder="Half Hourly Price" required />
                                    </div>

                                 </div>

                                 <div className="inputs mb-2">
                                    <div className="d-flex flex-column align-items-start">
                                       <label htmlFor="service_image">Service Image</label>
                                       <div className="d-flex align-items-center edit-image">
                                          <img
                                             src={
                                                selectedService?.service_image
                                                   ? typeof selectedService?.service_image === 'string'
                                                      ? selectedService?.service_image
                                                      : URL.createObjectURL(selectedService?.service_image)
                                                   : placeholderImg
                                             }
                                             alt="service_image"
                                          />
                                          <div className="edit-icon">
                                             <img src={edit} alt="edit-icon" />
                                             <input type="file" id="service_image" name="service_image" accept="image/png, image/jpeg, image/jpg"
                                                onChange={handleFileChange} />
                                          </div>

                                       </div>


                                    </div>
                                 </div>

                                 <div className="inputs mb-2">
                                    <div className=" d-flex flex-column align-items-start">
                                       <label htmlFor="serviceImage">About</label>
                                       <textarea name="about" onChange={handleChange} value={selectedService?.about} style={{ width: "100%" }} form="usrform" placeholder="About Service" />
                                    </div>
                                 </div>
                                 <div className="inputs mb-2 ">
                                    <div className="d-flex flex-column align-items-start">
                                       <label htmlFor="worker_category_id">Doorstep Category Id</label>
                                       <input onChange={handleChange} value={selectedService?.worker_category_id} readOnly type="text" id="worker_category_id" placeholder="Half Hourly Price" />
                                    </div>

                                 </div>
                                 <div className="inputs mb-2 ">
                                    <div className="d-flex flex-column align-items-start">
                                       <label htmlFor="category_name">Doorstep Category Name</label>
                                       <input onChange={handleChange} value={selectedService?.category_name} readOnly type="text" id="category_name" placeholder="Half Hourly Price" />
                                    </div>

                                 </div>
                              </div>
                              <div className="col-6">
                                 <div className="inputs  form-1 ">
                                    <div className="d-flex flex-column align-items-start">
                                       <label htmlFor="description">Description</label>
                                       {
                                          selectedService?.description?.map((data, id) => {
                                             return (
                                                <input
                                                   onChange={handleDescriptionChange}
                                                   key={id}
                                                   value={data || ""}
                                                   type="text"
                                                   id={`description${id}`}
                                                   name={`description-${id}`}
                                                   placeholder="Description"
                                                   className="mb-3"
                                                />
                                             )
                                          })
                                       }
                                    </div>
                                 </div>
                              </div>
                           </div>



                           {/* button down */}
                           <div className="col-md-12 d-flex  align-items-center justify-content-between">
                              <button type="button" className="btn btn-dark" onClick={() => setShow({
                                 ...show,
                                 edit: false
                              })}>Cancle</button>
                              <button type="submit" className="btn btn-primary">Update</button>

                           </div>

                        </form> :
                        show?.create && !isBackClicked ?
                           <div>
                              <form onSubmit={handleFormSubmit} className="form-div">
                                 <div className="main-form row">
                                    <div className="col-md-6">
                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start">
                                             <label htmlFor="doorstep_category_id">Doorstep Category Id</label>
                                             <select
                                                name="doorstep_category_id"
                                                value={selectedService?.worker_category_id}
                                                onChange={handleDropdownChange}
                                             >
                                                <option value="">Select Category Name</option>
                                                {categories && categories.map((value, index) => (
                                                   <option key={index} value={value._id}>
                                                      {value.category_name}
                                                   </option>
                                                ))}
                                             </select>
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start">
                                             <label htmlFor="service_title">Service Title</label>
                                             <input
                                                name="service_title"
                                                placeholder="Water Heater Installer"
                                                value={selectedService.service_title}
                                                onChange={handleChange}
                                             />
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start">
                                             <label htmlFor="price"> Price</label>
                                             <input
                                                name="price"
                                                placeholder="200"
                                                value={selectedService.price}
                                                onChange={handleChange}
                                             />
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start">
                                             <label htmlFor="working_basis">Working Basis</label>
                                             <select
                                                name="working_basis" // Change to "working_basis"
                                                value={selectedService?.working_basis}
                                                onChange={handleWorkBasisChange}
                                             >
                                                <option value="">Select Working Basis</option>
                                                <option value="Day">Day</option> {/* Use "Day" as the value */}
                                                <option value="Hour">Hour</option> {/* Use "Month" as the value */}
                                             </select>
                                          </div>

                                       </div>
                                       {
                                          selectedService?.working_basis === "Hour" ?
                                             <div className="inputs mb-2">
                                                <div className="d-flex flex-column align-items-start">
                                                   <label htmlFor="hours_count">Hours Count</label>
                                                   <input
                                                      name="hours_count"
                                                      placeholder="100"
                                                      value={selectedService.hours_count}
                                                      onChange={handleChange}
                                                   />
                                                </div>
                                             </div> :
                                             ""
                                       }


                                       <div className="inputs radio-sec">
                                          <div className="d-flex flex-column align-items-start">
                                             <label className="asking-div" style={{ color: "#848484" }}>
                                                Service Image
                                             </label>
                                             <input
                                                type="file"
                                                id="upload-doc"
                                                name="upload-doc"
                                                accept="image/png, image/jpeg, image/webp"
                                                onChange={handleFileChange}
                                             />
                                          </div>
                                       </div>
                                    </div>

                                    <div className="col-md-6">
                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start">
                                             <label htmlFor="about">About</label>
                                             <textarea
                                                name="about"
                                                placeholder="Plumbing services are of Top Quality."
                                                value={selectedService.about}
                                                onChange={handleChange}
                                             />
                                          </div>
                                       </div>

                                       <div className="inputs mb-2">
                                          <div className="d-flex flex-column align-items-start">
                                             <div className="d-flex justify-content-between" style={{ width: "100%", margin: "1rem 0px" }}>
                                                <label htmlFor="doorstepCategoryId" className="d-flex align-items-center">Service Description</label>
                                                <button type="button" className="btn btn-info" onClick={handleClick}>
                                                   <span>
                                                      Add Field
                                                   </span>
                                                </button>
                                             </div>
                                             {Array.from(Array(counter)).map((c, index) => (
                                                <div key={index} style={{ width: "100%" }}>
                                                   <input
                                                      onChange={handleOnChange}
                                                      key={c}
                                                      className={index.toString()}
                                                      type="text"
                                                      style={{ marginBottom: "10px" }}
                                                      value={c}

                                                   />
                                                </div>
                                             ))}
                                          </div>
                                       </div>
                                    </div>

                                    <div className="col-md-12 d-flex mt-5 align-items-center justify-content-between">
                                       <button type="button" className="btn btn-dark" onClick={() => setShow({
                                          ...show,
                                          create: false
                                       })}>Cancel</button>
                                       <button type="submit" className="btn btn-primary">{loading ? "Loading..." : "Submit"}</button>
                                    </div>
                                 </div>
                              </form>

                           </div>
                           :
                           <div>

                              <div className="d-flex justify-content-end mb-2" >

                                 <div className="d-flex justify-content-end gap-4 w-40">
                                    <Link to={`/professional/services/create`}>

                                    <span className="add-cat" onClick={() => onCreate()}>
                                       <button className="add-cat-btn">Add Service</button>
                                    </span>
                                    </Link>
                                 </div>

                              </div>
                              <div className="table-extra-responsive">
                                 <table className="table table-striped card-body">
                                    <thead>
                                       <tr className="category-tr">
                                          {/* <th scope="col" className="text-start ps-4">name</th> */}
                                          <th scope="col" className="text-start ps-4">Sr.No.</th>
                                          <th scope="col" className="text-start ps-4">Service Id</th>
                                          <th scope="col" className="text-start ps-4">Service Name</th>
                                          <th scope="col" className="text-start ps-4">Category Name</th>
                                          <th scope="col" className="text-start ps-4"> Price</th>

                                          {/* <th scope="col-2" className="text-start ps-4">Providers</th> */}


                                          <th scope="col" className="text-start ps-4">Icon</th>
                                          <th scope="col" className="col-lg-2 cat_btns">Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {
                                          doorStepServices && doorStepServices?.map((data: IProfessionalService, i) => {

                                             const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                                             return (
                                                <tr key={data?._id}>
                                                   {/* <th scope="row" className="text-start ps-4 pt-3">{data?.position}</th> */}
                                                   <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                                   <td className="text-start col-2 ps-4 pt-3">{data?._id}</td>
                                                   <td className="text-start ps-4 pt-3">{data?.service_title}</td>
                                                   <td className="text-start ps-4 pt-3">{data?.category_name}</td>
                                                   <td className="text-start ps-4 pt-3"> &#8377; {data?.price}</td>

                                                   {/* <td className="text-start ps-4 pt-3">{Providers}</td> */}

                                                   <td className="icon-td text-start ps-4">
                                                      <img src={data?.service_image} alt="categories" style={{ height: "70px", width: "100px" }} />
                                                   </td>

                                                   <td className="align-content-center ">
                                                      <div className="d-flex justify-content-center gap-3">
                                                         <Link to={`/professional/services/edit/${data?._id}`}>

                                                         <button className="btn btn-sm edit_btn" onClick={() => {
                                                            clickOnEdit(data?._id, "edit");
                                                            setIsBackClicked(false);
                                                            setHideAllFilters(true);
                                                         }}>
                                                            <img src={editIcon} />
                                                         </button>
                                                         </Link>
                                                         <Link to={`/professional/services/${data?._id}`}>

                                                         <button className="btn btn-sm delete_btn " onClick={() => {
                                                            clickOnEdit(data?._id, "view");
                                                            setIsBackClicked(false);
                                                            setHideAllFilters(true);

                                                         }}>
                                                            <img src={eye} />
                                                         </button>
                                                         </Link>
                                                         <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                                            <img src={deleteIcon} />
                                                         </button>
                                                      </div>

                                                   </td>
                                                </tr>
                                             )
                                          }
                                          )
                                       }


                                    </tbody>
                                 </table>
                              </div>



                              <Paginator
                                 totalPages={totalPages}
                                 pageNo={pageNo}
                                 onPageChange={(e, no) => setPageNo(no)}
                                 alignment="right"
                              />
                           </div>
               }

            </div>

         </div>

      </MainLayout>
   )

};



export default ProfessionalServices;